const languageNames = new Intl.DisplayNames(['en'], {
  type: 'language',
  fallback: 'none',
});

/**
 * Human-readable name for a BCP-47 tag ("nl-NL" → "Dutch (Netherlands)").
 * Unknown regions fall back to the language name, unknown tags to the raw tag.
 */
export const formatLanguageTag = (tag: string): string => {
  try {
    const name = languageNames.of(tag);
    if (name) return name;

    const primarySubtag = tag.split('-')[0];
    const primaryName = languageNames.of(primarySubtag);
    return primaryName || tag;
  } catch {
    return tag;
  }
};
